import React, { useCallback } from 'react';
import SpotifyPlaylistReportItemForm, {
    SpotifyPlaylistReportItemFormProps,
} from '../SpotifyPlaylistReportItemForm/SpotifyPlaylistReportItemForm';
import Modal, { ModalContent, ModalTitle } from '../../../../../ui/General/Modal/Modal';
import { postSpotifyPlaylistReportItem } from '../SpotifyReportItems.api';
import { mapApiErrorsToFormikErrors } from '../../../../../utility/utility';
import { showNotification } from '../../../../../helpers';

type CreateSpotifyPlaylistReportItemProps = {
    isModalOpen: boolean;
    onClose: () => void;
    onCreated: () => void;
};

const initialValues: SpotifyPlaylistReportItemFormProps['initialValues'] = {
    media_plan_item_id: undefined,
    amount_spent: undefined,
};

const CreateSpotifyPlaylistReportItem = ({ isModalOpen, onCreated, onClose }: CreateSpotifyPlaylistReportItemProps) => {
    const handleSubmit: SpotifyPlaylistReportItemFormProps['onSubmit'] = useCallback(
        async (values, { setSubmitting, setErrors }) => {
            try {
                setSubmitting(true);
                const response = await postSpotifyPlaylistReportItem({
                    media_plan_item_id: Number(values.media_plan_item_id),
                    amount_spent: Number(values.amount_spent),
                });

                if (response.status === 400) {
                    setErrors(mapApiErrorsToFormikErrors(response.data));
                    return;
                }

                showNotification('Report item created', 'info');
                onCreated();
            } catch (e) {
                showNotification('Could not create report item', 'error');
            } finally {
                setSubmitting(false);
            }
        },
        [onCreated]
    );

    return (
        <Modal closeOnOverlayClick isOpen={isModalOpen} onClose={onClose}>
            <ModalTitle>Create Spotify Playlist Report Item</ModalTitle>
            <ModalContent>
                <SpotifyPlaylistReportItemForm initialValues={initialValues} onSubmit={handleSubmit} />
            </ModalContent>
        </Modal>
    );
};

export default CreateSpotifyPlaylistReportItem;
